import { render, staticRenderFns } from "./InstitutionalStatistics.vue?vue&type=template&id=7d8f4543&scoped=true"
import script from "./InstitutionalStatistics.vue?vue&type=script&lang=js"
export * from "./InstitutionalStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8f4543",
  null
  
)

export default component.exports